import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Router from 'Components/UI/FacetRouter/FacetRouter';
import paths from 'paths';
import Maintenance from 'Components/Maintenance';
import ContentPicker from './ContentPicker';

const ContentRouter = () => {
  return (
    <Router>
      <Switch>
        {/* Routes */}
        <Route path={paths.maintenance} component={Maintenance} />
        <Route component={ContentPicker} />
      </Switch>
    </Router>
  );
};

export default ContentRouter;
